import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuizCountDownComponent } from './quiz-count-down.component';

@NgModule({
    declarations: [QuizCountDownComponent],
    exports: [QuizCountDownComponent],
    imports: [
        CommonModule
    ]
})
export class QuizCountDownModule { }
